var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('user-info',{attrs:{"account-id":_vm.accountId,"isCurrentUser":true,"formColSpan":6}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }